/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { FormFieldProps } from "@/shared/types/form-field";
import TextAreaInput, { TextAreaInputProps } from "../inputs/TextAreaInput";
import { FieldWrapper } from "./FieldWrapper";

export type TextAreaFieldProps = TextAreaInputProps & FormFieldProps;

const TextAreaField: Component<TextAreaFieldProps> = ({
  name,
  label,
  help,
  type = "text",
  disabled = false,
  leftAdornment,
  rightAdornment,
  rows = 1,
  sx,
  ...props
}) => {

  // Store input props to be repassed
  const inputProps = {
    type,
    ...props,
  };

  return (
    <FieldWrapper name={name} label={label} help={help} sx={sx}>
      <TextAreaInput
        name={name}
        {...inputProps}
        disabled={disabled}
        rows={rows}
      />
    </FieldWrapper>
  );
};

export default TextAreaField;
